<template>
  <FormModal
    v-if="!formSubmitted"
    @submit="handleSubmit"
  />
  <ConfirmationModal v-else />
</template>

<script
  lang="ts"
  setup
>
import { useAppBlur } from '@/helpers/ui';
import ConfirmationModal from './ConfirmationModal.vue';
import FormModal from './FormModal.vue';

const formSubmitted = ref(false);

const handleSubmit = () => {
  formSubmitted.value = true;
};

useAppBlur();
</script>
